module.exports = "/_next/static/images/btg-cb71b09f43ca7c259263914278f6d9ef.svg";